import React from 'react';
import { Query } from '@apollo/client/react/components';
import { SpecialPublicationQuery } from 'interfaces/graphql-typings';
const FetchSpecialPublication = require('buyside/graphql/queries/SpecialPublication');
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import SpecialPublicationPreAccess from './SpecialPublicationPreAccess';
import SpecialPublicationPreAccessBanner from './SpecialPublicationPreAccessBanner';

type SpecialPublicationPreAccessContainerProps = {
  specialPublicationId: string;
};

const SpecialPublicationPreAccessContainer: React.FunctionComponent<SpecialPublicationPreAccessContainerProps> = ({
  specialPublicationId
}): React.ReactElement => {
  return (
    <Query<SpecialPublicationQuery>
      query={FetchSpecialPublication}
      variables={{ id: specialPublicationId }}
    >
      {({ loading, data }): React.ReactElement => {
        if (loading || !data) return <LoadingSpinner size={SIZES.LARGE} />;
        const specialPublication = data?.specialPublication;

        return (
          <>
            <SpecialPublicationPreAccessBanner
              backgroundImage={specialPublication?.image || ''}
              headlineText="SUMZERO SPECIAL PUBLICATION ACCESS"
            />
            <SpecialPublicationPreAccess
              title={specialPublication?.title || ''}
              description={specialPublication?.description || ''}
              specialPublicationId={specialPublicationId}
              vanityName={specialPublication?.vanityName || ''}
            />
          </>
        );
      }}
    </Query>
  );
};

export default SpecialPublicationPreAccessContainer;
